(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gm-seemore"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gm-seemore')) {
    class GmSeeMore extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        const content = this.querySelector('[data-seemore-content]');
        const button = this.querySelector('[data-seemore-btn]');
        const label = this.querySelector('[data-seemore-label]');

        if (!content || !button || !label) return;

        this.dataset.initialized = 'true';

        button.addEventListener('click', () => {
          const isExpanded = content.classList.toggle('is-expanded');
          const translations = window.themeI18n || {};
          const labelMore = this.dataset.labelMore || translations.see_more || 'Voir plus';
          const labelLess = this.dataset.labelLess || translations.see_less || 'Voir moins';

          button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
          label.textContent = isExpanded ? labelLess : labelMore;
        });
      }
    }

    customElements.define('gm-seemore', GmSeeMore);
  }
  } catch(e) { console.error(e); }
})();

})();
